import AbstractIceContentController from '../../abstract/ice-content/controller';

const maintenance = "../maintenance.html";
const HELPERS = window.App.Utils.Helpers;
const dupApp = "dupApp";
const duplicate = "duplicate";

class Controller extends AbstractIceContentController {
    constructor(widget) {
        super(widget);
        this.init(widget);
    }

    init(widget) {

        const error404page = decodeURI(widget.getPreference('error404page'));
        const checkOTPsummary = widget.getPreference('checkOTPsummary');
        const codesExcluded = decodeURI(widget.getPreference('errorCodes'));
        const instiProductPage = decodeURI(widget.getPreference('instiProductsPage'));
        const confirmationPage = decodeURI(widget.getPreference('confirmationPage'));
        const url = `/${HELPERS.getRelativePath()}${confirmationPage}`;
        const confirmationDetailsFromStorage = sessionStorage.getItem("confirmationDetails");
        const otpSummaryFromStorage = sessionStorage.getItem("otpSummary");
        const decryptionEndpoint = HELPERS.adaptEnvironment(decodeURI(widget.getPreference('apiEndpoint')), true);
        const decryptionHeadersPref = decodeURI(widget.getPreference('decryptionHeaders'));
        const decryptionHeaders = JSON.parse(decryptionHeadersPref);

        if (b$.portal.loggedInUserGroup.length === 0) {

            if (checkOTPsummary) {
                if (!otpSummaryFromStorage) {
                    HELPERS.removeFromStorage();
                    HELPERS.replaceLocation(`/${HELPERS.getRelativePath()}${instiProductPage}`);
                }
            }

            App.PubSub.subscribe("decryptOTPSummary", function (otpSummary) {
                if (otpSummary.body && otpSummary.body.referenceNumber) {
                    if (window.location.href.indexOf(url) < 0) {
                        if (!confirmationDetailsFromStorage) {
                            sessionStorage.setItem(dupApp, duplicate);
                            HELPERS.replaceLocation(`/${HELPERS.getRelativePath()}${confirmationPage}`);
                        }
                    }
                }
            });

            if (checkOTPsummary) {
                HELPERS.encryptDecrypt(otpSummaryFromStorage, decryptionEndpoint, decryptionHeaders, true, "", "decryptOTPSummary");
            }

            App.PubSub.subscribe("redirectToErrorPage", function (result) {

                let isMaintenance = false;
                let errorPage = `/${HELPERS.getRelativePath()}${error404page}`;


                if (result.status === 400 || (result.status === 400 && codesExcluded.includes(result.code))) {
                    errorPage = result.errorPage;
                } else if (result.status !== 404) {
                    errorPage = result.errorPage;
                    isMaintenance = true;
                }

                const notHttpResponse = {
                    status: result.body.status,
                    description: result.body.description,
                    message: result.body.message,
                    withIcon: result.withIcon,
                    isMaintenance: isMaintenance
                };

                sessionStorage.setItem('notHttpResponse', JSON.stringify(notHttpResponse));
                HELPERS.replaceLocation(errorPage);

            });
        }
    }

}
export default Controller;



// WEBPACK FOOTER //
// ./collection-institutional-portal/src/widgets/widget-redirection/scripts/controller.js